export const API_BASE_URL = "https://apiitms.insurancedekho.com/";
export const LOCAL_STORAGE_USER_KEY = "insdocuser";
